import { defaultHttpClient } from '../../httpClient';

export interface ProductCheckoutGoodsOption {
  delivery_type: string;
  sno: number;
  text_option: string | null;
  ea: number;
}

export interface ProductCheckoutRequest {
  order_type: number;
  from_ablypay_benefit: boolean;
  coupon_snos: number[];
  goods_options: ProductCheckoutGoodsOption[];
}

export interface ProductCheckoutResponse {
  deeplink: string;
  checkout_key: string;
}

export const postProductCheckout = (body: ProductCheckoutRequest) => {
  return defaultHttpClient
    .request<ProductCheckoutResponse>({
      method: 'POST',
      url: '/api/v2/orders/product-checkout/',
      data: body,
    })
    .then(result => result.data);
};
